module.exports = __webpack_public_path__ + "static/photoshop-ce0076ad809d9b89715a26b87d037d62.png";